import React from "react";
import { HOME } from "@/constants/testIds";
import { Activity } from "lucide-react";

export const SiteFooter = () => {
  const cols = [
    {
      title: "Workspace Products",
      links: ["RFQ™", "CommodityBid™", "FreightIQ™", "Inspection™", "SmartContainer™", "Live Shipment Tracking™"],
    },
    {
      title: "Platform",
      links: ["Workspace", "Pricing", "Security", "Integrations", "Changelog"],
    },
    {
      title: "Company",
      links: ["About", "Customers", "Careers", "Press", "Contact"],
    },
    {
      title: "Resources",
      links: ["Docs", "API Reference", "Status", "Compliance", "Privacy"],
    },
  ];

  return (
    <footer
      data-testid={HOME.footer}
      className="relative border-t border-ink-10 bg-[hsl(var(--ivory))]"
    >
      <div className="container-narrow py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-2 font-display font-semibold ink">
              <span className="grid h-8 w-8 place-items-center rounded-lg bg-ink text-[hsl(var(--ivory))]">
                <Activity className="h-4 w-4" />
              </span>
              <span className="text-[15px] tracking-tight">DeMaxtore</span>
            </a>
            <p className="mt-4 text-[13.5px] ink-soft max-w-xs leading-relaxed">
              The import operating system. Workspace products for procurement,
              logistics and shipment intelligence.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[11px] font-mono ink-soft">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald" />
              All systems operational
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-[10.5px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
                  {c.title}
                </div>
                <ul className="space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#" className="text-[13px] ink hover:text-emerald transition-colors">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-ink-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-[12px] ink-soft font-mono">
            © {new Date().getFullYear()} DeMaxtore · Live Shipment Tracking™ is a Workspace Product.
          </div>
          <div className="text-[12px] ink-soft">Built for importers. Hosted globally.</div>
        </div>
      </div>
    </footer>
  );
};
